import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

const { border, color, font } = baseVariables;

export const StyledTextEditor = styled.div`
  position: relative;

  .menu {
    width: calc(100% - ${toRem(4)});
    height: ${toRem(40)};
    gap: ${toRem(8)};
    position: absolute;
    top: ${toRem(2)};
    left: ${toRem(2)};
    border-bottom: ${border.borderWidth02} ${border.borderStyleDefault} ${color.neutral30};
    z-index: 1;

    .menu-item {
      border-radius: ${toRem(4)};
      background: transparent;
      &:hover,
      &:focus,
      &.is-active {
        background-color: ${color.bvyAccent40};
      }
    }
  }

  .placeholder {
    font-size: ${font.fontM};
    line-height: ${font.lineHeightXl};
    position: absolute;
    top: ${toRem(48)};
    left: ${toRem(8)};
    opacity: 0.6;
    pointer-events: none;
  }

  .ProseMirror {
    padding: ${toRem(48)} ${toRem(8)} ${toRem(8)};
    min-height: ${toRem(200)};
    border: ${border.borderWidth02} ${border.borderStyleDefault} ${color.neutral40};
    border-radius: ${border.borderRadius02};
    text-align: center;
  }

  .ProseMirror-focused {
    outline: none;
    border-color: ${color.base10};
  }
  .ProseMirror a {
    font-weight: ${font.fontWeightRegular};
    text-decoration: underline;
  }

  .link-dialog-title {
    margin: 0 0 ${toRem(10)} 0;
    font-weight: 600;
  }

  .link-dialog-input {
    display: grid;
    gap: ${toRem(6)};
    margin-bottom: ${toRem(20)};
    margin-top: ${toRem(20)};
  }

  .link-dialog-actions {
    display: flex;
    gap: ${toRem(8)};
    justify-content: flex-end;
  }

  .color-palette {
    display: grid;
    grid-template-columns: repeat(6, ${toRem(24)});
    gap: ${toRem(8)};
    padding: ${toRem(8)};
  }

  .color-panel {
    width: max-content;
  }

  .color-panel-clear-btn {
    margin-top: ${toRem(8)};
    width: 100%;
  }

  .color-box {
    width: ${toRem(24)};
    height: ${toRem(24)};
    border-radius: ${toRem(4)};
    border: ${toRem(1)} solid ${color.neutral30};
    cursor: pointer;
  }

  .color-box:hover,
  .color-box:focus-visible {
    outline: ${toRem(2)} solid #005fcc;
    outline-offset: ${toRem(1)};
  }

  .color-box.is-selected {
    outline: ${toRem(2)} solid ${color.bvyAccent40};
    outline-offset: ${toRem(1)};
  }
`;
